import { useMutation } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import templateApi from '../services/templateApi';
import { formErrorMessageForToast } from '../utils/backEndErrorMessages';
import { useNavigate } from 'react-router-dom';

export const useDeleteTemplateDraft = () => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useMutation((templateUuid: string) => templateApi.deleteTemplateDraft(companyId, templateUuid), {
    onSuccess: (data) => {
      showToast({
        description: t('template.hooks.delete.success'),
        status: 'success',
        title: t('common.toast.success'),
        'data-cy': 'toast-delete-draft-success',
      });
      navigate('/doc-templates');
    },
    onError: (error) => {
      showToast({
        description: formErrorMessageForToast(t('template.hooks.delete.error'), error),
        status: 'error',
        title: t('common.toast.error'),
        'data-cy': 'toast-delete-draft-error',
      });
    },
  });
};
